import { Common } from '~/models/common';
import { Consultation } from '~/models/consultation';

export const consultationService = {
	fetch: async (): Promise<Consultation.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
			fields: ['*', 'image.*', 'imageMobile.*', 'form.*'],
		};

		try {
			const response = await $fetch<Consultation.Model[]>(Consultation.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Consultation:', error);

			return [];
		}
	},
};
